import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";

import { fetchWrapper } from "@helpers/fetchwrapper";
import notPhoto from "@content/img/notPhoto.jpg";

import newsStyles from "../home/blocks/styles/news.module.css";
import styles from "./styles/jobMarket.module.css";

function UsefulInfoNews() {
  const [news, setNews] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setLoad(true);
    fetchWrapper
      .get(
        `/v1/api/app/mainPageDataAdvanced?climit=2&plimit=12&rlimit=6&elimit=5&type=collegesAndInstitutions`
      )
      .then((res) => {
        if (!cancelled) {
          const sortedNews = [...(res?.Pages || [])].sort((a, b) => {
            const aDate = moment(a.SysPeriod?.LowerBound);
            const bDate = moment(b.SysPeriod?.LowerBound);

            return (
              (bDate.isValid() ? bDate.valueOf() : 0) -
              (aDate.isValid() ? aDate.valueOf() : 0)
            );
          });

          setNews(sortedNews);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setNews([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoad(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (load) {
    return (
      <div className={styles.newsLoader}>
        <ClipLoader color="#6E9A10" />
      </div>
    );
  }

  if (!news.length) {
    return (
      <p className={styles.note}>
        Новости временно недоступны. Загляните позже или откройте раздел «Все
        новости».
      </p>
    );
  }

  return (
    <div className={`${newsStyles.news} ${styles.newsBlock}`}>
      <div className={styles.newsToolbar}>
        <Link to="/all_news" className={newsStyles.more} target="_blank">
          Все новости
        </Link>
      </div>
      <Swiper
        modules={[Scrollbar]}
        scrollbar={{
          hide: false,
          draggable: true,
        }}
        slidesPerView={"auto"}
        spaceBetween={16}
        className={newsStyles.swiper}
      >
        {news.map((item) => (
          <SwiperSlide key={item.Id || item.Slug} className={newsStyles.slide}>
            <div className={newsStyles.card}>
              <div className={newsStyles.image}>
                {item.ImageLink ? (
                  <img
                    src={`/v1/api/fileManager/getFile?path=${item.ImageLink}`}
                    alt=""
                  />
                ) : (
                  <img src={notPhoto} alt="" />
                )}
              </div>
              <div className={newsStyles.info}>
                <div>
                  <div className={newsStyles.title}>{item.Title}</div>
                  <div className={newsStyles.description}>
                    {item.Description}
                  </div>
                </div>
                <div className={newsStyles.addition}>
                  <div className={newsStyles.date}>
                    {item.SysPeriod?.LowerBound
                      ? moment(item.SysPeriod.LowerBound).format("DD.MM.YYYY")
                      : ""}
                  </div>
                  <Link
                    to={`/news/${item.Slug}`}
                    className={newsStyles.more}
                    target="_blank"
                  >
                    Подробнее
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default UsefulInfoNews;
